function initializeTestimonials(scope = document) {
  scope.querySelectorAll('.testimonial__content:not([data-testimonial-initialized])').forEach((content) => {
    const text = content.querySelector('.testimonial__text');
    const button = content.querySelector('.testimonial__toggle');
    const label = button?.querySelector('span');

    if (!text || !button || !label) return;

    content.dataset.testimonialInitialized = 'true';
    const maxHeight = window.innerWidth <= 768 ? 250 : 60;

    if (text.scrollHeight <= maxHeight) {
      button.style.display = 'none';
      return;
    }

    button.addEventListener('click', () => {
      const isExpanded = text.dataset.expanded === 'true';

      text.style.maxHeight = isExpanded ? `${maxHeight}px` : `${text.scrollHeight}px`;
      text.dataset.expanded = String(!isExpanded);
      label.textContent = isExpanded ? 'Show more' : 'Show less';
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeTestimonials(), { once: true });
} else {
  initializeTestimonials();
}

document.addEventListener('shopify:section:load', (event) => initializeTestimonials(event.target));
